import React from 'react';
export function Guarantee() {
  return <section className="w-full px-4 lg:px-8 py-10 text-gray-900" style={{
    backgroundImage: 'linear-gradient(180deg, rgb(255,255,255) 0%, rgb(255,255,255) 15%, rgb(255,255,255) 85%, rgb(245,243,255) 100%)',
    fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, "Helvetica Neue", Arial, sans-serif'
  }} data-id="element-173">
      <div className="mx-auto max-w-2xl" data-id="element-174">
        <div className="rounded-2xl overflow-hidden shadow-sm" style={{
        border: '1px solid rgba(109, 40, 217, 0.3)'
      }} data-id="element-175">
          <div className="px-6 py-5 text-center" style={{
          background: 'linear-gradient(135deg, rgb(109, 40, 217), rgb(124, 58, 237))'
        }} data-id="element-176">
            <div className="text-5xl mb-3" data-id="element-177">🛡️</div>
            <h2 className="text-xl sm:text-2xl font-black text-white m-0" data-id="element-178">
              GARANTÍA MEGAPACK™ — 7 DÍAS
            </h2>
          </div>

          <div className="px-6 py-6 text-center" style={{
          backgroundColor: 'rgb(245, 243, 255)'
        }} data-id="element-179">
            <p className="text-sm text-gray-600 m-0 mb-2" data-id="element-180">
              Abrís los 6 tomos. Revisás los 6 bonos. Los usás en sesión si
              querés.
            </p>
            <p className="text-sm text-gray-600 m-0 mb-5" data-id="element-181">
              Si en 7 días no es lo que esperabas:
            </p>
            <p className="text-3xl font-black text-violet-700 m-0 mb-3" data-id="element-182">
              Te devolvemos el 100%.
            </p>
            <p className="text-base font-black text-gray-900 m-0" data-id="element-183">
              Sin preguntas. Sin formularios. Sin drama.
            </p>
          </div>

          <div className="px-6 py-4 text-center border-t" style={{
          backgroundColor: 'rgb(255,255,255)',
          borderColor: 'rgba(109, 40, 217, 0.15)'
        }} data-id="element-184">
            <p className="text-xs text-gray-500 m-0 leading-5" data-id="element-185">
              La confianza que tenemos en el Megapack Psicología Rentable nos
              permite hacer esa promesa sin dudar.
              <br data-id="element-186" />
              Más de 500 psicólogos de todo el país ya lo saben.
              <br data-id="element-187" />
              La tasa de devoluciones es menor al 1%.
            </p>
          </div>
        </div>
      </div>
    </section>;
}